<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">ECカテゴリ変換マスタ設定</th>
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="column-list">
          <label class="list-input-title">対象</label>
          <div class="block-row radio-group">
            <!-- 対象から "商品マスタ" を外すためコメントアウト -->
             <!--
            <app-radio-label #rdb_GoodsCategory label="商品マスタ" value="1" id="rdb_GoodsCategory"
              [subid]="'rdb_GoodsCategory'" [name]="'grp_CategoryDiv'" [forcedEnabledMode]="''"
              [(ngModel)]="kymw6801Model.radioGroup" [tabindex]="0" [disabled]="!kymw6801Model.disabledGoodsCategory">
            </app-radio-label> -->
            <app-radio-label #rdb_PlanCategory label="商品企画マスタ" value="2" id="rdb_PlanCategory"
              [subid]="'rdb_PlanCategory'" [name]="'grp_CategoryDiv'" [forcedEnabledMode]="''"
              [(ngModel)]="kymw6801Model.radioGroup" [tabindex]="0" [disabled]="!kymw6801Model.disabledPlanCategory">
            </app-radio-label>
            <app-radio-label #rdb_StockLimitFlg label="在庫限定" value="3" id="rdb_StockLimitFlg"
              [subid]="'rdb_StockLimitFlg'" [name]="'grp_CategoryDiv'" [forcedEnabledMode]="''"
              [(ngModel)]="kymw6801Model.radioGroup" [tabindex]="0" [disabled]="!kymw6801Model.disabledStockLimitFlg">
            </app-radio-label>
          </div>

          <label class="list-input-title">変換区分</label>
          <div class="list-input-content">
            <app-kymw68-conv-div-combo-box id="cmb_ConvDiv" [subid]="'cmb_ConvDiv'" [categoryDiv]="kymw6801Model.radioGroup"
              [blank]="true" [forcedEnabledMode]="''" [tabindex]="0" (change)="eventConvDiv_CHANGEHandler()" [style.width.%]="100"
              [(ngModel)]="kymw6801Model.convDiv" #cmb_ConvDiv [autofocus]="true">
            </app-kymw68-conv-div-combo-box>
          </div>

          <label class="list-input-title">カテゴリ</label>
          <div class="list-input-content">
            <input type="text" id="lbl_CategoryCode" #lbl_CategoryCode value="{{kymw6801Model.categoryCode}}" readonly>
          </div>

          <label class="list-input-title">部門</label>
          <div class="list-input-content">
            <app-class-code-combo-box #cmb_ClassCode id="cmb_ClassCode" [subid]="'cmb_ClassCode'"
              [disabled]="!cmb_ConvDiv.selectedClassCodeCtrl" [forcedEnabledMode]="''" [initFocusItem]="cmb_ConvDiv"
              [tabindex]="0" [blank]="true"></app-class-code-combo-box>
          </div>

          <label class="list-input-title">大分類</label>
          <div class="list-input-content">
            <app-large-class-code-combo-box #cmb_LargeClassCode id="cmb_LargeClassCode" [subid]="'cmb_LargeClassCode'"
              [disabled]="!cmb_ConvDiv.selectedLargeClassCodeCtrl" [forcedEnabledMode]="''" [tabindex]="0"
              [blank]="true" [classCodeComboBoxFlg]="true" [classCode]="cmb_ClassCode.selectedClassCode">
            </app-large-class-code-combo-box>
          </div>

          <label class="list-input-title">中分類</label>
          <div class="list-input-content">
            <app-middle-class-code-combo-box #cmb_MiddleClassCode id="cmb_MiddleClassCode"
              [subid]="'cmb_MiddleClassCode'" [disabled]="!cmb_ConvDiv.selectedMiddleClassCodeCtrl" [tabindex]="0"
              [blank]="true" [forcedEnabledMode]="''" [classCodeComboBoxFlg]="true" [largeClassCodeComboBoxFlg]="true"
              [classCode]="cmb_ClassCode.selectedClassCode"
              [largeClassCode]="cmb_LargeClassCode.selectedLargeClassCode">
            </app-middle-class-code-combo-box>
          </div>

          <label class="list-input-title">小分類</label>
          <div class="list-input-content">
            <app-small-class-code-combo-box #cmb_SmallClassCode id="cmb_SmallClassCode" [subid]="'cmb_SmallClassCode'"
              [disabled]="!cmb_ConvDiv.selectedSmallClassCodeCtrl" [tabindex]="0" [blank]="true"
              [forcedEnabledMode]="''" [classCodeComboBoxFlg]="true" [largeClassCodeComboBoxFlg]="true"
              [classCode]="cmb_ClassCode.selectedClassCode"
              [middleClassCode]="cmb_MiddleClassCode.selectedMiddleClassCode">
            </app-small-class-code-combo-box>
          </div>

          <label class="list-input-title">マーク１</label>
          <div class="list-input-content">
            <div class="element-row">
              <app-mark-code-text-input class="mark_input" id="txti_MarkCode1" [subid]="'txti_MarkCode1'"
                [maxlength]="3" [restrict]="'[0-9]'" [forcedEnabledMode]="''"
                [disabled]="!cmb_ConvDiv.selectedMarkCode1Ctrl" [markNameField]="lbl_MarkNameDown1" [tabindex]="0"
                [(ngModel)]="kymw6801Model.markCode1" #txti_MarkCode1>
              </app-mark-code-text-input>
              <input type="text" readonly class="disabled-border mark_display" id="lbl_MarkNameDown1" #lbl_MarkNameDown1
                forcedEnabledMode="true" value="{{kymw6801Model.markNameDown1}}">
            </div>
          </div>

          <label class="list-input-title">マーク２</label>
          <div class="list-input-content">
            <div class="element-row">
              <app-mark-code-text-input class="mark_input" [maxlength]="3" [restrict]="'[0-9]'" id="txti_MarkCode2"
                [subid]="'txti_MarkCode2'" [disabled]="!cmb_ConvDiv.selectedMarkCode2Ctrl"
                [markNameField]="lbl_MarkNameDown2" [tabindex]="0" [forcedEnabledMode]="''"
                [(ngModel)]="kymw6801Model.markCode2" #txti_MarkCode2>
              </app-mark-code-text-input>
              <input type="text" readonly class="disabled-border mark_display" id="lbl_MarkNameDown2" #lbl_MarkNameDown2
                forcedEnabledMode="true" value="{{kymw6801Model.markNameDown2}}">
            </div>
          </div>

          <label class="list-input-title">マーク３</label>
          <div class="list-input-content">
            <div class="element-row">
              <app-mark-code-text-input class="mark_input" [maxlength]="3" [restrict]="'[0-9]'" id="txti_MarkCode3"
                [subid]="'txti_MarkCode3'" [disabled]="!cmb_ConvDiv.selectedMarkCode3Ctrl"
                [markNameField]="lbl_MarkNameDown3" [tabindex]="0" [forcedEnabledMode]="''"
                [(ngModel)]="kymw6801Model.markCode3" #txti_MarkCode3>
              </app-mark-code-text-input>
              <input type="text" readonly class="disabled-border mark_display" id="lbl_MarkNameDown3" #lbl_MarkNameDown3
                forcedEnabledMode="true" value="{{kymw6801Model.markNameDown3}}">
            </div>
          </div>

          <label class="list-input-title">価格パターン</label>
          <div class="list-input-content">
            <app-code-combo-box id="cmb_PricePattern" [subid]="'cmb_PricePattern'"
              [disabled]="!cmb_ConvDiv.selectedPricePatternCtrl" [forcedEnabledMode]="''" [tabindex]="0"
              [(ngModel)]="kymw6801Model.pricePattern" [labelField]="'codeValueName'" [codeDiv]="'ct355'"
              #cmb_PricePattern [autofocus]="true">
            </app-code-combo-box>
          </div>

          <label class="list-input-title">媒体</label>
          <div class="list-input-content">
            <app-plan-medium-type-combo-box id="cmb_MediumType" [subid]="'cmb_MediumType'"
              [disabled]="!cmb_ConvDiv.selectedMediumTypeCtrl" [forcedEnabledMode]="''" [tabindex]="0"
              [(ngModel)]="kymw6801Model.mediumType" (ngModelChange)="eventMediumType_CHANGEHandler()" #cmb_MediumType style="width: 100%;">
            </app-plan-medium-type-combo-box>
          </div>

          <label class="list-input-title">特集</label>
          <div class="list-input-content">
            <app-kymw68-feature-code-combo-box id="cmb_FeatureCode" [subid]="'cmb_FeatureCode'" [width]="344"
              [disabled]="!cmb_ConvDiv.selectedFeatureCodeCtrl" [forcedEnabledMode]="''" [tabindex]="0"
              [(ngModel)]="kymw6801Model.featureCode" [mediumType]="kymw6801Model.mediumType" #cmb_FeatureCode
              (loadCompleted)="featureCodeLoadCompleted($event)" [initFocusItem]="cmb_MediumType">
            </app-kymw68-feature-code-combo-box>
          </div>

          <label class="list-input-title">ページ</label>
          <div class="list-input-content">
            <input type="text" plessInputTextSub [maxlength]="3" [restrict]="'[0-9]'" id="txti_PageNum"
              [disabled]="!cmb_ConvDiv.selectedPageNumCtrl" [tabindex]="0" forcedEnabledMode=""
              [(ngModel)]="kymw6801Model.pageNum" #txti_PageNum>
          </div>

          <label class="list-input-title">プロモーション区分</label>
          <div class="list-input-content">
            <app-promotion-code-combo-box id="cmb_ProDiv" [subid]="'cmb_ProDiv'"
              [disabled]="!cmb_ConvDiv.selectedPromotionDivCtrl" [codeDiv]="'ct350'" [forcedEnabledMode]="''"
              [initFocusItem]="cmb_ConvDiv" [tabindex]="0" #cmb_ProDiv (change)="eventProDiv_CHANGEHandler()"
              [(ngModel)]="kymw6801Model.promotionDiv">
            </app-promotion-code-combo-box>
          </div>

          <label class="list-input-title">プロモーション情報</label>
          <div class="list-input-content">
            <app-promotion-code-combo-box id="cmb_ProInfo" [subid]="'cmb_ProInfo'"
              [disabled]="!cmb_ConvDiv.selectedPromotionDivCtrl" [codeDiv]="'ctp109'" [initFocusItem]="cmb_ConvDiv"
              [reserve1]="cmb_ProDiv.selectedCodeValue" [forcedEnabledMode]="''" [tabindex]="0"
              [(ngModel)]="kymw6801Model.promotionInfo" #cmb_ProInfo>
            </app-promotion-code-combo-box>
          </div>

          <label class="list-input-title">催事</label>
          <div class="list-input-content">
            <input type="text" plessInputTextSub [maxlength]="8" id="txti_ExhibitionDiv" [restrict]="'[0-9]'"
              [disabled]="!cmb_ConvDiv.selectedExhibitionDivCtrl" [tabindex]="0" forcedEnabledMode=""
              [(ngModel)]="kymw6801Model.exhibitionDiv" #txti_ExhibitionDiv>
          </div>

          <label class="list-input-title">タグ１</label>
          <div class="list-input-content">
            <app-kymw68-tag-combo-box #tag1 id="cmb_Tag1" [subid]="'cmb_Tag1'" [width]="344"
              [disabled]="!cmb_ConvDiv.selectedTag1Ctrl" [forcedEnabledMode]="''" [initFocusItem]="cmb_ConvDiv"
              [tabindex]="0" [(ngModel)]="kymw6801Model.tag1" #cmb_Tag1>
            </app-kymw68-tag-combo-box>
          </div>

          <label class="list-input-title">タグ２</label>
          <div class="list-input-content">
            <app-kymw68-tag-combo-box #tag2 id="cmb_Tag2" [subid]="'cmb_Tag2'" [width]="344"
              [disabled]="!cmb_ConvDiv.selectedTag2Ctrl" [forcedEnabledMode]="''" [initFocusItem]="cmb_ConvDiv"
              [tabindex]="0" [(ngModel)]="kymw6801Model.tag2" #cmb_Tag2>
            </app-kymw68-tag-combo-box>
          </div>

        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button class="btn-tartiary warning" forcedEnabledMode="" [tabindex]="0" (click)="eventDelete_CLICKHandler()"
            #btn_Delete id="btn_Delete">削除</button>
          <button class="btn-primary" forcedEnabledMode="" [tabindex]="0" id="btn_Update" #btn_Update
            (click)="eventUpdate_CLICKHandler()">更新</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="eventClose_CLICKHandler()" #btn_Close></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>